export function calculatePricingLevel (pricingLevel, cost, price) {
    let result = null;

    if (pricingLevel.modifier_type === 'fixed') {
        result = pricingLevel.modifier_amount;
    } else if (pricingLevel.modifier_type === 'cost_plus') {
        result = cost + pricingLevel.modifier_amount;
    } else if (pricingLevel.modifier_type === 'percent_off_price') {
        const discount = price * (pricingLevel.modifier_amount / 100);
        result = price - discount;
    } else if (pricingLevel.modifier_type === 'margin') {
        const divisor = 1 - (pricingLevel.modifier_amount / 100);
        result = cost / divisor;
    }

    return result;
}